<script>
import SimpleModal from '@/Components/Utilities/SimpleModal'
export default {
    components: {
        SimpleModal
    },
    data: () => ({
        helpOpen: false,
        showVideoModal: false,
        loadVideo: false
    }),
    computed: {
        helpDrawer() {
            return this.$page.props.helpDrawer
        },
        supportWebsite() {
            return this.$page.props.supportWebsite
        },
        oemSupportEmail() {
            return this.$page.props.oemSupportEmail
        },
    }
}
</script>

<template>
    <button
        class="flex items-center px-4 space-x-2 h-8 font-semibold text-spotler-gray-600 hover:text-spotler-honesty bg-spotler-gray-200 hover:bg-white rounded-l-full border border-r-0 border-spotler-gray-200 hover:border-spotler-honesty focus:outline-none xs"
        @click="helpOpen = true"
    >
        <i class="text-sm fas fa-question" />
        <span class="hidden text-xs uppercase lg:block">{{ __('Help') }}</span>
    </button>
    <transition
        name="fade"
        mode="out-in"
    >
        <div
            v-if="helpOpen"
            class="fixed top-0 right-0 z-50 w-96 h-full min-h-screen max-h-screen shadow-left"
        >
            <div class="absolute top-12 left-0 -mt-4 -ml-8">
                <button
                    class="flex justify-center items-center space-x-2 w-8 h-8 font-semibold text-white hover:text-spotler-knowledge bg-spotler-knowledge hover:bg-white rounded-l-full border border-r-0 border-spotler-knowledge focus:outline-none xs"
                    @click="helpOpen = false"
                >
                    <i
                        class="text-sm fas fa-times"
                        aria-hidden="true"
                    />
                </button>
            </div>
            <div
                v-if="helpDrawer"
                class="flex flex-col h-full bg-spotler-conceptual-lighter"
            >
                <div
                    class="flex items-center px-6 space-x-4 h-24 text-3xl text-rss-grayblue-300 bg-spotler-knowledge"
                    :class="{ 'text-2xl': helpDrawer.DrawerTitle.length > 14 }"
                >
                    <span>
                        <i :class="'fas ' + ($page.props.icons[helpDrawer.page_name.toLowerCase()] ?? 'fa-question') " />
                    </span>
                    <span>{{ helpDrawer.DrawerTitle }}</span>
                </div>
                <div
                    v-if="helpDrawer.VideoURL"
                    class="py-3 px-6 text-white bg-spotler-conceptual-darker"
                >
                    <a
                        class="flex items-center leading-5"
                        href="#"
                        title="Play help video"
                        @click="showVideoModal = true"
                    >
                        <span>
                            <i class="fas fa-film" />
                        </span>
                        <span class="ml-2 text-sm">{{ helpDrawer.VideoTitle }}</span>
                        <span class="ml-4">
                            <i class="fas fa-play" />
                        </span>
                        <SimpleModal
                            v-if="showVideoModal"
                            v-slot="{close}"
                            v-model="showVideoModal"
                            modal-classes="w-full max-w-3xl py-4 px-6"
                        >
                            <div class="flex justify-between pb-4 border-b">
                                <h4>{{ helpDrawer.VideoTitle }}</h4>
                                <button @click="close">
                                    <i class="fa fa-times" />
                                </button>
                            </div>
                            <div class="aspect-video relative mt-4 bg-black">
                                <div
                                    class="group flex absolute inset-0 justify-center items-center cursor-pointer"
                                    @click="loadVideo = true"
                                >
                                    <div
                                        class="absolute inset-0 bg-center bg-cover group-hover:opacity-75 transition duration-400"
                                        :style="'background-image: url(https://i.ytimg.com/vi/' + helpDrawer.VideoURL + '/hqdefault.jpg)'"
                                    />
                                    <div
                                        class="relative w-[72px] h-[72px]"
                                        :style="'background-image: url(/img/play.png)'"
                                    />
                                </div>
                                <iframe
                                    v-if="loadVideo"
                                    class="absolute inset-0 w-full h-full border-none"
                                    :src="'https://www.youtube.com/embed/' + helpDrawer.VideoURL + '?autoplay=1&rel=0'"
                                    :allowfullscreen="true"
                                />
                            </div>
                        </SimpleModal>
                    </a>
                </div>
                <div class="overflow-y-scroll py-4 px-6 h-full text-sm bg-spotler-conceptual-lighter">
                    <div
                        class="prose prose-sm"
                        v-html="helpDrawer.HelpText"
                    />
                </div>
                <div
                    v-if="helpDrawer.MoreInfoURL"
                    class="py-5 text-center"
                >
                    <a

                        :href="helpDrawer.MoreInfoURL"
                        target="_blank"
                        class="py-1 px-4 text-xs text-white uppercase bg-rss-blue"
                    >
                        Find Out More
                    </a>
                </div>
            </div>
            <div
                v-else
                class="flex flex-col h-full"
            >
                <div class="flex items-center px-6 space-x-4 h-24 text-3xl text-rss-grayblue-300 bg-spotler-conceptual-darker">
                    <span>
                        <i class="fas fa-fire-extinguisher" />
                    </span>
                    <span>Stuck?</span>
                </div>
                <div class="overflow-scroll py-4 px-6 h-full text-sm bg-spotler-conceptual-lighter">
                    <p class="mb-3">
                        If you're having difficulties with your CRM and not finding the answers you  need,
                        do take a look at our <a
                            :href="supportWebsite"
                            title="View our support pages"
                            target="_blank"
                            class="font-bold"
                        >Support Hub</a> for more detailed explanations.
                    </p>
                    <p class="mb-3">
                        You can also contact our Customer Support team for help, free of charge, by emailing your question(s)
                        to <a
                            :href="'mailto:' + oemSupportEmail"
                            title="Email our support team"
                            class="font-bold"
                        >{{ oemSupportEmail }}</a>.
                    </p>
                    <p class="mb-3">
                        And if you think any of the information in these Help Drawers or our Support Hub is unclear do get
                        in touch using our <a
                            :href="supportWebsite + '/feedback'"
                            title="Give us some feedback"
                            target="_blank"
                            class="font-bold"
                        >Feedback form</a>.
                    </p>
                </div>
            </div>
        </div>
    </transition>
</template>
